// Util javascript functions that are or could be used in multiple places in the project have a home here.

// Used to delay execution of code.
export async function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}